export default "__VITE_ASSET__NODNki3r__"